import { PropsWithChildren } from 'react'
import { fetcher } from '../utils/fetcher'
import { useAuthDispatch, useToken } from '../utils/hooks'
import { ActionsContext } from '../contexts/Actions.context'
import { LOCAL_STORAGE_KEY } from '../utils/config'
import { AuthActionType } from '../reducers/AuthState.reducer'

const ActionsProvider = ({ children }: PropsWithChildren) => {
  const token = useToken()
  const authDispatch = useAuthDispatch()

  const triggerRebuild = async () => {
    await fetcher({
      path: 'customer/trigger-site-rebuild',
      auth: token,
    })
  }

  const signOut = async () => {
    localStorage.removeItem(LOCAL_STORAGE_KEY)
    authDispatch({
      type: AuthActionType.replaceState,
      data: { isAuthenticating: false },
    })
  }

  return (
    <ActionsContext.Provider
      value={{
        triggerRebuild,
        signOut,
      }}
    >
      {children}
    </ActionsContext.Provider>
  )
}

export default ActionsProvider
